// extracted by mini-css-extract-plugin
export default {"root":"ConfirmMergeModal_root__l8W4b","buttonContainer":"ConfirmMergeModal_buttonContainer__KDC8a","address":"ConfirmMergeModal_address__K-uVs"};